import React from 'react';
import { Box, Chip, Paper, Stack, Typography } from '@mui/material';
import { formatDateTimeEAT } from '../../shared/formatDateTimeEAT';
import { externalLoanCardSx, externalLoanNestedCardSx } from './externalLoanCardStyles';

const statusMeta = (guarantor = {}, activeApproverRole = null) => {
  const status = guarantor.status || (guarantor.rejected ? 'rejected' : guarantor.approved ? 'approved' : 'pending');
  if (status === 'rejected') return { label: 'Rejected', color: 'error' };
  if (status === 'approved') return { label: 'Approved', color: 'success' };
  if (guarantor.role === activeApproverRole) return { label: 'Current approver', color: 'info' };
  return { label: 'Pending', color: 'warning' };
};

const ApprovalsTabPanel = ({ guarantors, activeApproverRole }) => (
  <Paper
    elevation={0}
    sx={{
      p: 2.5,
      ...externalLoanCardSx,
    }}
  >
    <Stack spacing={2}>
      <Typography variant="h6" fontWeight={700}>Guarantor approvals</Typography>
      <Typography variant="body2" color="text.secondary">Approvals are shown in a compact, stage-aware workflow.</Typography>
      {guarantors.map((guarantor, index) => {
        const meta = statusMeta(guarantor, activeApproverRole);
        return (
          <Box key={guarantor.role} sx={{ p: 2, ...externalLoanNestedCardSx }}>
            <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="space-between" spacing={1}>
              <Box>
                <Typography fontWeight={700}>{index + 1}. {guarantor.role}</Typography>
                <Typography variant="body2">{guarantor.name} • {guarantor.phone}</Typography>
                {guarantor.approvedAt ? (
                  <Typography variant="caption" color="text.secondary">Approved {formatDateTimeEAT(guarantor.approvedAt)}</Typography>
                ) : null}
                {guarantor.rejectionReason ? (
                  <Typography variant="caption" color="error.main">{guarantor.rejectionReason}</Typography>
                ) : null}
              </Box>
              <Chip label={meta.label} color={meta.color} size="small" />
            </Stack>
          </Box>
        );
      })}
    </Stack>
  </Paper>
);

export default ApprovalsTabPanel;
